























































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { format, parseISO, isAfter } from "date-fns";

@Component({})
export default class MeetupsCardManage extends Vue {
    @Prop() editMeetup: any;
    @Prop() meetups: any;
    @Prop() showSpinner: any;
    @Prop() community: any;

    public showSidepanel: boolean = false;

    public checkReservations(meetup) {
        if (meetup.reservations) {
            if (meetup.reservations.count) {
                return true;
            }
        }
        return false;
    }

    public waitingUsers(meetup) {
        return meetup.reservations && meetup.reservations.waiting
            ? meetup.reservations.waiting
            : 0;
    }

    public hasStarted(meetup) {
        return isAfter(new Date(), parseISO(meetup.start_datetime+"Z"));
    }

    // public getPartecipantsListUrl(meetupId) {
    //     return process.env.VUE_APP_MEETUP_API_ENDPOINT.replace(
    //         "/api",
    //         `/report/meetup/${meetupId}/attendees`
    //     );
    // }

    public getMeetupReservations(meetup) {
        let seats = meetup.seats_total;
        if (meetup.reservations && meetup.reservations.count) {
            seats -= meetup.reservations.count;
        }
        return seats;
    }

    public goToCheckin(meetup) {
        this.$store.commit("setMeetup", meetup);
        this.$router.push(
            `/communities/${this.community.id}/manage/meetups/${meetup.id}/checkin`
        );
    }

    public attendeesList(meetup) {
        this.$store.commit("setMeetup", meetup);
        this.$router.push(
            `/communities/${this.community.id}/manage/meetups/${meetup.id}/attendees`
        );
    }

    public goToAgenda(meetup) {
        this.$store.commit("setMeetup", meetup);
        this.$router.push(
            `/communities/${this.community.id}/manage/meetups/${meetup.id}/agenda`
        );
    }

    public goToManageEmails(meetup) {
        this.$store.commit("setMeetup", meetup);
        this.$router.push(
            `/communities/${this.community.id}/manage/meetups/${meetup.id}/emails`
        );
    }

    public managePapers(meetup) {
        this.$store.commit("setMeetup", meetup);
        this.$router.push(
            `/communities/${this.community.id}/manage/meetups/${meetup.id}/submissions`
        );
    }

    public format = format;
    public parseISO = parseISO;
}
